import { RootState } from "../../index";

export const getDispatchOriginsByMissionId = (state: RootState) =>
  state.dispatchOrigins.byMissionId;

export const getDispatchOriginStopId = (
  state: RootState,
  missionId: string
): string | undefined => state.dispatchOrigins.byMissionId[missionId];
